import { Grid, Typography, Box } from "@mui/material";
import React from "react";

import { useTranslation } from "react-i18next";

import Header from "../../Containers/Header";

import Identification from "../../Containers/OnBoarding/identification";

import { ComponentType } from "../../common/enum";

const AddBranch = () => {
  const { t } = useTranslation();

  return (
    <Box pb="20px">
      <Box zIndex={20} bgcolor={"#F9FAFC"} position={"sticky"} top={0}>
        <Header t={t}/>
      </Box>
      <Typography px="108px" py={4} variant="h4">
        {t("addBranch")}
      </Typography>
      <Identification
        identificationType={ComponentType.IDENTIFICATION_TYPE}
        details={[]}
        setDetails={[]}
        block={[]}
        t={t}
      />
    </Box>
  );
};

export default AddBranch;
